import { createFileRoute } from '@tanstack/react-router';
import { PageBuilderPage } from '../../features/content';

export const Route = createFileRoute('/admin/content/pages/$id')({
  component: function PageBuilderRoute() {
    const { id } = Route.useParams();
    return <PageBuilderPage id={id} />;
  },
});
